export enum EControlActions {
  addNode = 'Knoten hinzufügen',
  arrange = 'Anordnen',
  arrangeAll = 'Alle anordnen',
  attendance = 'Anwesenheit bescheinigen',
  attestation = 'Bescheinigen',
  cancel = 'Stornieren',
  change = 'Ändern',
  changeLine = 'Zellenwert ändern', // not for custom action
  changeName = 'Knotennamen ändern',
  changeNodePosition = 'Knotenposition ändern',
  changeSelectionEntry = 'Selektionseintrag ändern',
  check = 'Geprüftstatus togglen',
  confirm = 'Änderungen bestätigen',
  connection = 'Neue Verbindung anlegen',
  contract = 'Vertrag',
  copaymentInvoicePreview = 'Eigenanteilrechnung anzeigen',
  copy = 'Duplizieren', // not for custom action
  create = 'Erstellen', // not for custom action
  createCustom = 'Aus Auswahl erstellen',
  createFromDefault = 'Von Standard erstellen',
  credit = 'Gutschrift',
  csvExport = "CSV-Export", // not for custom action
  csvImport = "CSV-Import", // not for custom action
  customer = 'Kunde',
  delete = 'Löschen', // not for custom action
  deleteInvoice = 'Rechnung löschen',
  deleteSelectionEntry = 'Selektionseintrag löschen',
  deprecate = 'Verwerfen',
  detail = 'Verknüpfte Sicht öffnen',
  device = 'Neues Gerät anlegen',
  dunning = 'Mahnung erstellen',
  edit = 'Ändern',
  editAll = 'Alle ändern',
  editRow = 'Zeile bearbeiten', // not for custom action
  etl = 'ETL-Schritt ausführen',
  execute = 'Erzeugen',
  export = 'Exportieren',
  import = 'Importieren',
  invoice = 'Rechnung erstellen',
  changeElsid = 'ELSID ändern',
  invoicePreview = 'Rechnung anzeigen',
  jsonExport = "JSON-Export",
  jsonImport = "JSON-Import",
  load = 'Laden',
  loadAll = 'Alle laden',
  key = 'Neuen Schlüsseltyp anlegen',
  map = 'Zuordnen',
  mail = 'Elektronische Post',
  newCondition = 'Neue Regel anlegen',
  newMission = 'Neuer Einsatz',
  newNode = 'Neuen Knoten erstellen',
  newOrdinance = 'Neue Dauerverordnung anlegen',
  newReference = 'Neue Referenz setzen',
  newSelectionEntry = 'Selektionseintrag erstellen',
  partlyCancel = 'Teilstornieren',
  cancelItemValue = 'Position kürzen',
  payed = 'Bezahlt',
  phone = 'Neuen Telefontyp erstellen',
  preview = 'Vorschau anzeigen',
  recalculateItemPriceHistory = 'Preise rückwirkend anwenden',
  reinvoice = 'Rechnung erneut erzeugen',
  removeNode = 'Knoten löschen',
  replaceClientForCart = 'Patientendaten der Fahrt ersetzen',
  reroll = 'Reroll',
  rerollAll = 'Vollständiger Reroll',
  resetpassword = 'Passwort ändern',
  resolveClientMessage = 'Patientennachrichten auflösen',
  resynchronize = 'Resynchronisieren',
  rollback = 'Rückgängig',
  rule = 'ETL-Regeln öffnen',
  selectAll = 'Alle selektieren', // not for custom action
  successor = 'Nachfolger',
  synchronize = 'Synchronisieren',
  tariffChange = 'Tarifänderung',
  tariffOption = 'Tarifoptionen',
  uncollectible = 'Uneinbringlich',
  undo = 'Aktion zurücknehmen',
  variantCreate = 'Variante erstellen',
  passToCollectionAgency = 'An Inkasso Übergeben',
}

export const changes = new Set([
  EControlActions.changeLine,
  EControlActions.create,
  EControlActions.delete,
  EControlActions.copy,
])
